const DEFAULT_DISPLAY_LANG = "fr";

const normalizeLangCode = (code) => String(code || "").trim().toLowerCase();
const getPrimaryLang = (code) => normalizeLangCode(code).split(/[-_]/)[0] || "";

const findLanguageOptionCode = (options, preferredCode) => {
  const preferred = normalizeLangCode(preferredCode);
  if (!preferred) return "";

  return (
    options.find((option) => normalizeLangCode(option.code) === preferred)?.code ||
    options.find((option) => getPrimaryLang(option.code) === getPrimaryLang(preferred))?.code ||
    ""
  );
};

export function resolveLanguageCatalogState(data, currentState = {}) {
  const defs = data?.defaults || {};
  const sttOptions = Array.isArray(data?.stt_options) ? data.stt_options : [];
  const translationOptions = Array.isArray(data?.translation_options)
    ? data.translation_options
    : [];
  const hasSttSource = sttOptions.some((option) => option.code === currentState.sttSourceLang);
  const hasTranslationTarget = translationOptions.some(
    (option) => option.code === currentState.translationTargetLang
  );
  const defaultTranslationTarget =
    findLanguageOptionCode(translationOptions, DEFAULT_DISPLAY_LANG) ||
    defs.translation_target_lang ||
    translationOptions[0]?.code ||
    "";

  return {
    sttLanguageOptions: sttOptions,
    translationLanguageOptions: translationOptions,
    ...(!currentState.sttSourceLang || !hasSttSource
      ? { sttSourceLang: defs.stt_source_lang || sttOptions[0]?.code || "" }
      : {}),
    ...(!currentState.translationTargetLang || !hasTranslationTarget
      ? { translationTargetLang: defaultTranslationTarget }
      : {}),
  };
}
